module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.optimizeResume),
      expression: "optimizeResume"
    }],
    staticClass: "optimizeResume"
  }, [_vm._v("简历快速优化中……")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.controlCode),
      expression: "controlCode"
    }],
    staticClass: "controlCode btns",
    on: {
      "click": _vm.controlCodeEve
    }
  }, [_vm._v(_vm._s(_vm.controlCodeText))]), _vm._v(" "), _c('aside', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.state === 'over'),
      expression: "state === 'over'"
    }]
  }, [_c('ul', _vm._l((_vm.asideArr), function(item, index) {
    return _c('li', {
      key: index
    }, [(_vm.isFirefox() && item.tag === 'PDF下载') ? _c('a', {
      attrs: {
        "href": item.link,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v(_vm._s(item.tag))]) : _c('a', {
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.tag))])])
  }))]), _vm._v(" "), _c('StyleEditor', {
    ref: "styleEditor",
    attrs: {
      "code": _vm.currentStyle
    }
  }), _vm._v(" "), _c('ResumeEditor', {
    ref: "resumeEditor",
    attrs: {
      "markdown": _vm.currentMarkdown,
      "enableHtml": _vm.enableHtml
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showControl),
      expression: "showControl"
    }],
    staticClass: "control clearfix"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.interval != 0 && _vm.state != 'over'),
      expression: "interval != 0  && state != 'over' "
    }],
    staticClass: "speedUp btns",
    attrs: {
      "id": "speedUp"
    },
    on: {
      "click": _vm.speedUp
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "id": "icon",
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-yingyongjiasuqi"
    }
  })]), _vm._v("\n        加速\n      ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.state != 'stop' && _vm.state != 'over'),
      expression: "state != 'stop' && state != 'over' "
    }],
    staticClass: "stop btns",
    attrs: {
      "id": "stop"
    },
    on: {
      "click": _vm.stop
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "id": "icon",
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-tag35"
    }
  })]), _vm._v("\n        停止\n      ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.state === 'stop' && _vm.state != 'over'),
      expression: "state === 'stop' && state != 'over' "
    }],
    staticClass: "keepOn btns",
    attrs: {
      "id": "keepOn"
    },
    on: {
      "click": _vm.keepOn
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "id": "icon",
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-rightsanjiao-copy"
    }
  })]), _vm._v("\n        继续\n      ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.state != 'over'),
      expression: "state != 'over' "
    }],
    staticClass: "skip btns",
    attrs: {
      "id": "skip"
    },
    on: {
      "click": _vm.skip
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "id": "icon",
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-tiaoguo"
    }
  })]), _vm._v("\n        跳过\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "again btns",
    attrs: {
      "id": "again"
    },
    on: {
      "click": _vm.again
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "id": "icon",
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-tiaoguo"
    }
  })]), _vm._v("\n        重来\n      ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/._vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-3de0e1b8","hasScoped":true}!./~/._vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 95
// module chunks = 1